export const LABELS = {
    play: 'Play',
    pause: 'Pause',
    reload: 'Reload',
    dragDrop: 'Drag and drop',
    backward: 'Backward',
    forward: 'Forward',
    close:'Close'
};